import React from "react";
import Helmet from "react-helmet";

const defaultTitle = "Kelas Seni";

export default function Title({ title }) {
  return (
    <>
      <Helmet>
        <title>
          Kelas Seni{title ? `${" | "}${title ?? ""}` : defaultTitle}
        </title>
      </Helmet>
    </>
  );
}
